module.exports = __webpack_public_path__ + "static/media/logo-inverse.d672e27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/logo-inverse.png
// module id = 91
// module chunks = 0